
import { createAction, handleActions } from 'redux-actions';

const setShowEditOrderItemModal = createAction("SCREENS/VALUATION_VIEW/SET_SHOW_EDIT_ORDER_ITEM_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [setShowEditOrderItemModal]: (state, action) => action.payload
  },
  defaultState
);

export { setShowEditOrderItemModal, reducer };